<template>
  <div class="app" v-if="user">
    <AppHeader />
    <div class="app-body">
      <Sidebar />
      <main class="main">
        <div
          class="card card-inverse card-success text-center"
          v-if="staging()"
        >
          <div class="card-block">
            <blockquote class="card-blockquote">
              Interface de <strong>test</strong> -
              manager-staging.justcoaching.fr
            </blockquote>
          </div>
        </div>
        <Breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view :key="$route.fullPath"></router-view>
        </div>
      </main>
    </div>
    <AppFooter />
    <ChangeCoachPassword :email="user.email" />
    <ConfirmModal />
  </div>
</template>

<script>
import { mapState } from "vuex";

import AppHeader from "@/components/layout/Header";
import Sidebar from "@/components/layout/Sidebar";
import AppFooter from "@/components/layout/Footer";
import Breadcrumb from "@/components/layout/Breadcrumb";
import ChangeCoachPassword from "@/components/modal/ChangeCoachPassword";

export default {
  name: "full",
  components: {
    AppHeader,
    Sidebar,
    AppFooter,
    Breadcrumb,
    ChangeCoachPassword,
  },

  async created() {
    if (!this.$store.state.user) {
      try {
        const { data } = await this.$api.post("/users/refresh-token");
        this.$store.commit("AUTH_TOKEN", data.accessToken);
      } catch (_) {
        // refresh failed
      }

      if (!this.$store.state.user) {
        if (this.$route.name !== "login") {
          this.$router.push({ name: "login" });
        }
        return;
      }
    }

    if (this.isTeam(this.$store.state.user)) {
      this.$store.dispatch("loadMerchants");
      this.$store.dispatch("loadConcepts");
      this.$store.dispatch("loadInvoiceSeries");
      this.$store.dispatch("loadRightAccessSettings");
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    list() {
      return this.$route.matched;
    },
  },

  methods: {
    staging() {
      return window.location.host === "manager-staging.justcoaching.fr";
    },
  },
};
</script>

<style lang="scss" scoped>
.app-body {
  overflow-x: hidden !important;

  @media (max-width: 1200px) {
    overflow-x: auto !important;
  }
}
</style>
